import { render, staticRenderFns } from "./VehicleInfo.vue?vue&type=template&id=32890342&scoped=true&"
import script from "./VehicleInfo.vue?vue&type=script&lang=js&"
export * from "./VehicleInfo.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInfo.vue?vue&type=style&index=0&id=32890342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32890342",
  null
  
)

export default component.exports